import { IContextInfo, IDeviceInfoData, ISearchContextInfo, IUserInfo } from '../types';
import getCookie from '@stencil/flights-utils/src/get-cookie';

// const GEO_INFO = {};

export const getContext = (travelType, rid, pageUrl = ''): IContextInfo => {
  const timeStamp = String(Date.now());
  const rightNow = new Date();
  const timeZone = String(String(rightNow).split('(')[1]).split(')')[0];
  const timeZoneAbbr = timeZone
    .split(' ')
    .map(char => char.charAt(0))
    .join('');
  const page_url = pageUrl
    ? pageUrl
    : window && window.location && window.location.href
    ? window.location.href
    : '';
  const sbu = `${travelType.toLowerCase()}_flights`;
  let funnel_page_name = '';
  if (page_url.includes('air-')) {
    funnel_page_name = 'SRP';
  } else if (page_url.includes('flight-review')) {
    funnel_page_name = 'Booking Review Page';
  } else if (page_url.includes('/flights/')) {
    funnel_page_name = 'Flights Home';
  } else {
    funnel_page_name = 'Home';
  }

  return {
    client_timestamp: timeStamp,
    client_timezone: timeZoneAbbr,
    environment: process.env.NODE_ENV || 'development',
    page_url,
    bu: 'flights',
    sbu,
    funnel_page_name,
    template_id: '112321',
    funnel_source: 'GI',
    data_source: 'client',
    correlation_id: rid
  };
};

export const getDevice = (flavour): IDeviceInfoData => {
  const nAgt = navigator.userAgent;
  let browserName = navigator.appName;
  let fullVersion = '' + parseFloat(navigator.appVersion);
  let majorVersion = parseInt(navigator.appVersion, 10);
  let nameOffset;
  let verOffset;
  let ix;

  if (nAgt.indexOf('OPR/') !== -1) {
    // In Opera 15+, the true version is after "OPR/"
    verOffset = nAgt.indexOf('OPR/');
    browserName = 'Opera';
    fullVersion = nAgt.substring(verOffset + 4);
  } else if (nAgt.indexOf('Opera') !== -1) {
    // In older Opera, the true version is after "Opera" or after "Version"
    verOffset = nAgt.indexOf('Opera');
    browserName = 'Opera';
    fullVersion = nAgt.substring(verOffset + 6);
    if (nAgt.indexOf('Version') !== -1) {
      verOffset = nAgt.indexOf('Version');
      fullVersion = nAgt.substring(verOffset + 8);
    }
  } else if (nAgt.indexOf('MSIE') !== -1) {
    // In MSIE, the true version is after "MSIE" in userAgent
    verOffset = nAgt.indexOf('MSIE');
    browserName = 'Microsoft Internet Explorer';
    fullVersion = nAgt.substring(verOffset + 5);
  } else if (nAgt.indexOf('Chrome') !== -1) {
    // In Chrome, the true version is after "Chrome"
    verOffset = nAgt.indexOf('Chrome');
    browserName = 'Chrome';
    fullVersion = nAgt.substring(verOffset + 7);
  } else if (nAgt.indexOf('Safari') !== -1) {
    // In Safari, the true version is after "Safari" or after "Version"
    verOffset = nAgt.indexOf('Safari');
    browserName = 'Safari';
    fullVersion = nAgt.substring(verOffset + 7);
    if (nAgt.indexOf('Version') !== -1) {
      verOffset = nAgt.indexOf('Version');
      fullVersion = nAgt.substring(verOffset + 8);
    }
  } else if (nAgt.indexOf('Firefox') !== -1) {
    // In Firefox, the true version is after "Firefox"
    verOffset = nAgt.indexOf('Firefox');
    browserName = 'Firefox';
    fullVersion = nAgt.substring(verOffset + 8);
  } else if (nAgt.lastIndexOf(' ') + 1 < nAgt.lastIndexOf('/')) {
    // In most other browsers, "name/version" is at the end of userAgent
    nameOffset = nAgt.lastIndexOf(' ') + 1;
    verOffset = nAgt.lastIndexOf('/');
    browserName = nAgt.substring(nameOffset, verOffset);
    fullVersion = nAgt.substring(verOffset + 1);
    if (browserName.toLowerCase() === browserName.toUpperCase()) {
      browserName = navigator.appName;
    }
  }
  // trim the fullVersion string at semicolon/space if present
  if (fullVersion.indexOf(';') !== -1) {
    ix = fullVersion.indexOf(';');
    fullVersion = fullVersion.substring(0, ix);
  }
  if (fullVersion.indexOf(' ') !== -1) {
    ix = fullVersion.indexOf(' ');
    fullVersion = fullVersion.substring(0, ix);
  }

  majorVersion = parseInt('' + fullVersion, 10);
  if (isNaN(majorVersion)) {
    fullVersion = '' + parseFloat(navigator.appVersion);
    majorVersion = parseInt(navigator.appVersion, 10);
  }
  // console.log(''
  //   + 'Browser name  = ' + browserName + '<br>'
  //   + 'Full version  = ' + fullVersion + '<br>'
  //   + 'Major version = ' + majorVersion + '<br>'
  //   + 'navigator.appName = ' + navigator.appName + '<br>'
  //   + 'navigator.userAgent = ' + navigator.userAgent + '<br>'
  // );

  const urlParams = new window.URLSearchParams(location.search);
  const utm_source = urlParams.get('utm_source') || urlParams.get('gi_source') || '';
  const utm_medium = urlParams.get('utm_medium') || urlParams.get('gi_medium') || '';

  return {
    browser: browserName,
    browser_version: fullVersion,
    flavour: flavour || 'Mobile',
    user_agent: nAgt,
    // ...(GEO_INFO.geo_latitude ? {geo_latitude: GEO_INFO.geo_latitude} : null),
    // ...(GEO_INFO.geo_longitude ? {geo_longitude: GEO_INFO.geo_longitude} : null),
    // geo_citylatlong,
    traffic_country: 'india',
    traffic_currency: 'inr',
    traffic_language: navigator && navigator.language ? navigator.language : 'en',
    traffic_medium: utm_medium || 'GI',
    traffic_source: utm_source || 'GI'
  };
};

export const getSearchContext = (homeStore): ISearchContextInfo => {
  const {
    journey_type,
    passengers = {},
    travel_class,
    src = {},
    dest = {},
    travelType,
    dep = {},
    arr = {},
    fare_type = ''
  } = homeStore;
  const { adult, child, infant } = passengers;
  const { iata: srcIata = '', xtr: srcXTR = {} } = src;
  const { iata: destIata = '', xtr: destXTR = {} } = dest;
  const { cc: srcCC = '' } = srcXTR;
  const { cc: destCC = '' } = destXTR;
  const { yyyymmdd: depDateForUrl = '' } = dep;
  const { yyyymmdd: arrDateForUrl = '' } = arr ? arr : {};
  const depDateForUrlInt = depDateForUrl ? parseInt(depDateForUrl, 10) : 0;
  const arrDateForUrlInt = arrDateForUrl ? parseInt(arrDateForUrl, 10) : 0;
  return {
    journey_type,
    fare_type,
    total_adults: adult,
    total_children: child,
    total_infants: infant,
    total_pax: adult + child + infant,
    travel_class,
    details: [
      {
        source_code: srcIata,
        source_country: srcCC,
        destination_code: destIata,
        destination_country: destCC,
        sector_type: travelType,
        traveldate: depDateForUrlInt,
        arr_traveldate: arrDateForUrlInt
      }
    ]
  };
};

export const getUser = (): IUserInfo | Object => {
  const gaCookie = getCookie('_ga') || '';
  const gaCookieArray = gaCookie.split('.');
  gaCookieArray.splice(0, 2);
  const marketing_cloud_id = gaCookieArray.join('.');
  if (window && window.userInfo && Object.keys(window.userInfo).length > 0) {
    const { hashedemail, profile_type, uuid } = window.userInfo;
    return {
      email_commid: hashedemail,
      is_logged_in: true,
      login_channel: '',
      mobile_commid: '',
      profile_type,
      uuid,
      mobile_country_code: '91',
      hydra_segment_list: '',
      marketing_cloud_id
    };
  }
  return {
    email_commid: '',
    marketing_cloud_id
  };
};
